var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFireExtinguisher = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "fire_extinguisher_svg__a",
  d: "M10 2.942h20V32H10z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinejoin: "round",
  d: "M18.828 9.536h-1.11c-2.528 0-4.552 2.053-4.552 4.64V31.5h10.247V14.176c0-2.587-2.03-4.64-4.585-4.64Z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "fire_extinguisher_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#fire_extinguisher_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinejoin: "round",
  d: "M23.413 25.914h-5.695V15.682h5.695zM19.721 9.536h-2.863V5.471h2.863zM29.5 10.36l-6.087-2.58V6.02L29.5 3.442zM23.149 6.903h-3.428M10.5 10.825v-.778c0-1.757 1.374-3.145 3.104-3.145h3.151",
  mask: "url(#fire_extinguisher_svg__b)"
}))));
export default SvgFireExtinguisher;